import { hbs } from 'ember-cli-htmlbars';
import { Error, toggleConfirmCancelInvitationModal, userClickCancelInvitationAction, userClickConfirmCancelInvitationAction, userClickResendInvitationAction } from '@banking/ui/workflows/card-invitation-management';
import { workflowComponent } from '@banking/ui/services/card-invitation-management';
import { mapStateToInvitationManagementState } from '@banking/ui/components/banking/checking/card-invitation/card-invitation-utils';
const template = hbs`
  <Banking::Checking::CardInvitation::CardInvitationManagement
    @state={{this.state}}
    @businessName={{this.businessName}}
    @cancelInvitationModalOpen={{this.cancelInvitationModalOpen}}
    @cancelInvitationModalLoading={{this.cancelInvitationModalLoading}}
    @cancelInvitationModalError={{this.cancelInvitationModalError}}
    @invitee={{this.invitee}}
    @resendCardInvitationButtonLoading={{this.resendCardInvitationButtonLoading}}
    @resendCardInvitationToastStatus={{this.resendCardInvitationToastStatus}}
    @onCancelInvitationClick={{this.onCancelInvitationClick}}
    @onCancelInvitationClose={{this.onCancelInvitationClose}}
    @onCancelInvitationConfirm={{this.onCancelInvitationConfirm}}
    @onResendInvitationClick={{this.onResendInvitationClick}}
  />`;
const mapStateToProps = workflowState => ({
  businessName: workflowState.businessName,
  cancelInvitationModalOpen: workflowState.confirmCancelInvitationModalOpen,
  cancelInvitationModalLoading: workflowState.confirmCancelInvitationModalLoading,
  cancelInvitationModalError: workflowState.error.includes(Error.InvitationRevokeError),
  invitee: workflowState.invitee,
  resendCardInvitationButtonLoading: workflowState.resendCardInvitationButtonLoading,
  resendCardInvitationToastStatus: workflowState.resendCardInvitationToastStatus,
  state: mapStateToInvitationManagementState(workflowState)
});
const mapActionsToProps = () => ({
  onCancelInvitationClick: userClickCancelInvitationAction,
  onCancelInvitationClose: () => toggleConfirmCancelInvitationModal(false),
  onCancelInvitationConfirm: userClickConfirmCancelInvitationAction,
  onResendInvitationClick: userClickResendInvitationAction
});
export default workflowComponent(mapStateToProps, mapActionsToProps)(template);